import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={64.586} height={38.251} {...props}>
    <g data-name="Group 4810">
      <path
        data-name="Path 7580"
        d="M1529.578 1080.652h-17.584a14.809 14.809 0 1 0 17.584 0zm-2.291 4.157h-5.173a4.7 4.7 0 0 1 1.76 3.2h3.413v1.57h-3.387c-.313 3.2-2.849 5.235-6.862 5.358 2.442 2.537 5.107 5.738 7.739 8.962h-3.007c-2.447-2.944-4.732-5.671-7.677-8.805v-1.945h1.721c3.386 0 5.2-1.408 5.42-3.57h-7.134V1088h7.052c-.441-1.816-2.1-2.727-4.827-2.727h-2.225v-2.033h13.192z"
        transform="translate(-1491.231 -1075.858)"
        style={{
          fill: '#fff'
        }}
      />
      <path
        data-name="Path 7581"
        d="M1528.3 1080.652a16 16 0 1 1-21.339 0h-7.7a4.281 4.281 0 0 1 .47 1.961 4.366 4.366 0 0 1-4.364 4.363 4.284 4.284 0 0 1-1.81-.4v22.736H1545a2.184 2.184 0 0 0 2.185-2.185v-26.478zm12.27 26.49a4.364 4.364 0 1 1 4.358-4.364 4.363 4.363 0 0 1-4.362 4.364z"
        transform="translate(-1488.072 -1075.858)"
        style={{
          fill: '#fff'
        }}
      />
      <path
        data-name="Path 7582"
        d="M1552.657 1082.837v29.088a2.184 2.184 0 0 1-2.185 2.185h-54.74a2.183 2.183 0 0 1-2.18-2.185v-1.491H1545a3.305 3.305 0 0 0 3.3-3.3v-26.478h2.174a2.184 2.184 0 0 1 2.183 2.181z"
        transform="translate(-1488.072 -1075.858)"
        style={{
          fill: '#fff'
        }}
      />
      <path
        data-name="Path 7583"
        d="M1524.549 1079.016a14.8 14.8 0 1 0 6.017 11.913 14.723 14.723 0 0 0-6.017-11.913zm-2.291 4.157h-5.173a4.7 4.7 0 0 1 1.76 3.2h3.414v1.57h-3.386c-.312 3.2-2.849 5.235-6.861 5.358 2.442 2.537 5.107 5.738 7.739 8.962h-3.006c-2.447-2.945-4.733-5.671-7.677-8.805v-1.945h1.721c3.386 0 5.2-1.408 5.42-3.57h-7.141v-1.57h7.052c-.441-1.816-2.1-2.727-4.827-2.727h-2.224v-2.033h13.192zm2.291-4.157a14.8 14.8 0 1 0 6.017 11.913 14.723 14.723 0 0 0-6.017-11.913zm-2.291 4.157h-5.173a4.7 4.7 0 0 1 1.76 3.2h3.414v1.57h-3.386c-.312 3.2-2.849 5.235-6.861 5.358 2.442 2.537 5.107 5.738 7.739 8.962h-3.006c-2.447-2.945-4.733-5.671-7.677-8.805v-1.945h1.721c3.386 0 5.2-1.408 5.42-3.57h-7.141v-1.57h7.052c-.441-1.816-2.1-2.727-4.827-2.727h-2.224v-2.033h13.192zm20.869-8.952h-54.74a2.185 2.185 0 0 0-2.185 2.185v29.094a2.184 2.184 0 0 0 2.185 2.185h54.74a2.184 2.184 0 0 0 2.185-2.185v-29.089a2.184 2.184 0 0 0-2.186-2.189zm-49.633 11.119a4.286 4.286 0 0 1-1.81-.4 4.36 4.36 0 1 1 5.7-5.928 4.281 4.281 0 0 1 .47 1.961 4.366 4.366 0 0 1-4.361 4.368zm45.2 20.165a4.364 4.364 0 1 1 4.358-4.363 4.363 4.363 0 0 1-4.352 4.364zm-6.94-14.577a16.022 16.022 0 1 1-5.33-11.913 16.012 16.012 0 0 1 5.332 11.914zm-24.791-11.913a14.778 14.778 0 1 0 8.795-2.9 14.8 14.8 0 0 0-8.793 2.901zm15.292 4.157h-5.173a4.7 4.7 0 0 1 1.76 3.2h3.414v1.57h-3.386c-.312 3.2-2.849 5.235-6.861 5.358 2.442 2.537 5.107 5.738 7.739 8.962h-3.006c-2.447-2.945-4.733-5.671-7.677-8.805v-1.945h1.721c3.386 0 5.2-1.408 5.42-3.57h-7.141v-1.57h7.052c-.441-1.816-2.1-2.727-4.827-2.727h-2.224v-2.033h13.192z"
        transform="translate(-1486.202 -1074.222)"
        style={{
          fill: '#fff'
        }}
      />
    </g>
  </svg>
);

export default SvgComponent;
